import domain from './domain';

// Reset brand profile
export const resetBrandProfile = domain.createEvent('resetBrandProfile');

// Reset brand profile assets
export const resetBrandProfileAssets = domain.createEvent('resetBrandProfileAssets');
